module["exports"] = [
  "#{Name.last_name} #{suffix}",
  "#{Name.last_name}-#{Name.last_name}",
  "#{Name.last_name}, #{Name.last_name} e #{Name.last_name}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pt_BR/company/name.js
 ** module id = 955
 ** module chunks = 0
 **/